export const isPreviouslySelectedTurnModeAtFirstPage = (
  noeEntekhab,
  department,
  steps
) => {
  const condition =
    (Number(noeEntekhab) !== 3 && steps === 1) ||
    (department?.NobatBaPezeshKYaVahed === 2 &&
      steps === 1);

  // console.log('is previously Selected =>', {
  //   noeEntekhab,
  //   department,
  //   steps,
  // });

  return condition;
};
